import { ReactElement, useCallback } from 'react';
import { App, Form } from 'antd';
import { styled } from 'styled-components';
import { UpdateAdvisorBody } from '@minutes-system/backend/src/api/advisors/schema';
import { useNavigate, useParams } from 'react-router-dom';
import useAdvisorDetail from '../hooks/useAdvisorDetail';
import Buttons from './content/Buttons';
import { blockStyle } from '../../../../components/styles/Block';
import Fields from './content/Fields';

const ContentBlock = styled.article`
  ${blockStyle}
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const FormCard = styled.div`
  width: 320px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
`;

interface AdvisorFormValue {
  name: string;
  phone: string;
}

const Content = (): ReactElement => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const advisorId = Number(id);
  const [form] = Form.useForm<AdvisorFormValue>();
  const { message } = App.useApp();
  const { advisor, updateAdvisor } = useAdvisorDetail(advisorId);

  const handleCancel = useCallback(() => {
    void navigate('/advisors');
  }, [navigate]);

  const onFinish = useCallback(
    async (values: AdvisorFormValue) => {
      try {
        const body: UpdateAdvisorBody = {
          name: values.name.trim(),
          phone: values.phone,
        };

        if (body.name === advisor.name && body.phone === advisor.phone) {
          return;
        }

        const result = await updateAdvisor(body);
        if (result.success) {
          message.success('営業担当者情報を更新しました');
          void navigate('/advisors');
        }
      } catch (error) {
        console.error('Failed to update advisor:', error);
        message.error('営業担当者情報の更新に失敗しました');
      }
    },
    [updateAdvisor, message, advisor, navigate]
  );

  return (
    <ContentBlock>
      <FormCard>
        <Form<AdvisorFormValue>
          form={form}
          layout='vertical'
          onFinish={values => {
            void onFinish(values);
          }}
          initialValues={{
            name: advisor.name,
            phone: advisor.phone,
          }}
        >
          <Fields />
          <Buttons onCancel={handleCancel} />
        </Form>
      </FormCard>
    </ContentBlock>
  );
};

export default Content;
